module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Pompeii.a296db7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Pompeii.jpg
// module id = vjxo
// module chunks = 0